import React,{ Component } from 'react';
import {Col, Row, Card, CardBody, Table } from "reactstrap";
import { Line } from 'react-chartjs-2';
import ReactTable from "react-table";
import { Link } from 'react-router-dom'
import { fuzzySearch } from "../../../../utils/helpers";

class UserTable extends Component {
    constructor(props) {
        super(props);
    }

    formatSeconds(secs) {
        if (secs < 60) {
            return <div><strong>{secs}</strong>sec</div>
        } else if (secs < 3600) {
            let minutes = Math.floor(secs / 60);
            let seconds = secs % 60;
            return <div><strong>{minutes}</strong>min <strong>{seconds}</strong>secs</div>
        } else {
            let hour = Math.floor(secs / 3600);
            secs = secs - hour * 3600;
            let minutes = Math.floor(secs / 60);
            let seconds = secs % 60;
            return <div><strong>{hour}</strong>hr <strong>{minutes}</strong>min <strong>{seconds}</strong>secs</div>
        }
    }

    render() {
        const columns = [
            {
                Header: "User",
                accessor: "name",
                filterMethod: fuzzySearch,
                Cell: (props) => {
                    return <div >
                            <Link
                                style={{color: 'black'}}
                                to={{
                                    pathname: '/logging',
                                    state: {
                                        level: 'INFO',
                                        username: props.value,
                                        start_date: this.props.selectOpen ? this.props.start_date : null,
                                        end_date: this.props.selectOpen ? this.props.end_date: null,
                                        delta: this.props.delta,
                                    }
                                }}
                            >
                                {props.value}
                            </Link>
                        </div>
                }
            },
            {
                Header: "Total Kasm Usage",
                accessor: "kasm_length",
                filterable: false,
                Cell: (props) => {
                    return <div>{this.formatSeconds(Math.round(props.value))}</div>
                }
            },
            {
                Header: "Average Kasm Usage",
                accessor: "avg_kasm_length",
                filterable: false,
                Cell: (props) => {
                    return <div>{this.formatSeconds(Math.round(props.value))}</div>
                }
            },
            {
                Header: "Longest Session",
                accessor: "longest_session",
                filterable: false,
                Cell: (props) => {
                    return <div>{this.formatSeconds(Math.round(props.value))}</div>
                }
            },
            {
                Header: "Shortest Session",
                accessor: "shortest_session",
                filterable: false,
                Cell: (props) => {
                    return <div>{this.formatSeconds(Math.round(props.value))}</div>
                }
            }
        ];
        return (
            <div>
                {this.props.users.data &&
                    <ReactTable
                        columns={columns}
                        data={this.props.users.data}
                        filterable
                        defaultSorted={[{id: "kasm_length", desc: true}]}
                        defaultPageSize={5}
                        className="-striped -highlight"
                    />
                }
            </div>
        );
    }
}

export default UserTable;


// WEBPACK FOOTER //
// ./src/views/Reporting/ReportDashboard/ReportComponents/UserTable.js